<template>
    <div class="main">
        <c-panel title="Capa da Caderneta (Diário de Classe)" titleIcon="fas fa-book">
            <el-form label-position="top">
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="18" :md="18">
                        <el-form-item label="Instituição" key="instituicao" v-if="$store.state.user.tipo == 10 || ($store.state.user.tipo > 3 && $store.state.user.tipo <= 8)">
                            <el-select ref="instituicao_id" v-model="filtro.instituicao_id" filterable placeholder="Pesquisar Instituição" clearable>
                                <el-option v-for="(item, i) in $store.state.instituicoes" :key="i" :label="item.nome" :value="item.id"> </el-option>
                            </el-select>
                        </el-form-item>
                        <div class="style-form" v-if="$store.state.user.tipo <= 3 || $store.state.user.tipo == 9">
                            <label class="el-form-item__label">Instituição</label>
                            <div class="style-input readonly">{{ $store.state.config.instituicao.nome }}</div>
                        </div>
                    </el-col>
                    <el-col :xs="24" :sm="6" :md="6">
                        <el-form-item label="Ano *" key="ano">
                            <el-input v-model="filtro.ano" maxlength="4" v-mask="'####'" placeholder="Ex.: 2026"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="10">
                    <el-col :xs="24" :sm="14" :md="14">
                        <el-form-item label="Nome da turma *" key="turma_nome">
                            <el-input v-model="filtro.turma_nome" maxlength="191" placeholder="Ex.: 5º ANO A"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="10" :md="10">
                        <el-form-item label="Turno *" key="turno">
                            <el-select v-model="filtro.turno" clearable placeholder="Selecione">
                                <el-option v-for="(label, k) in $CONSTANTS.TURNO" :key="k" :label="label" :value="parseInt(k)"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <div class="u-text-right u-mt-10">
                    <el-button type="primary" @click="emitPrint()">IMPRIMIR CAPA</el-button>
                </div>
            </el-form>
        </c-panel>
    </div>
</template>

<script>
export default {
    data: () => ({
        filtro: {
            instituicao_id: '',
            turma_nome: '',
            ano: new Date().getFullYear().toString(),
            turno: ''
        }
    }),
    mounted () {
        // default instituição para usuários com instituição fixa
        if (this.$store.state.user.tipo <= 3 || this.$store.state.user.tipo == 9) {
            this.filtro.instituicao_id = this.$store.state.config.instituicao.id
        }
    },
    methods: {
        validate () {
            if (!this.filtro.instituicao_id) return 'Informe a instituição.'
            if (!this.filtro.turma_nome) return 'Informe o nome da turma.'
            if (!this.filtro.ano) return 'Informe o ano.'
            if (this.filtro.turno === '' || this.filtro.turno === null) return 'Informe o turno.'
            return null
        },
        emitPrint () {
            const err = this.validate()
            if (err) return window.eventBus.$emit('alert', { msg: err, type: 'warning' })

            window.eventBus.$emit('print', {
                url: '/api/pdf/renderCapaCaderneta',
                param: { filtros: this.filtro }
            })
        }
    }
}
</script>

